import { Inject, NgModule, Optional, SkipSelf } from '@angular/core';

import { RtUICommonModule } from '../common/common.module';
import { DialogBodyComponent } from './dialog-body/dialog-body.component';
import { DialogCloseModule } from './dialog-close/dialog-close.module';
import {
  buildDialogConfig,
  DialogConfig,
  DialogConfigOptions,
  DialogRole,
  DialogWidth,
} from './dialog-config';
import {
  DialogContainerAnimationState,
  DialogContainerComponent,
} from './dialog-container/dialog-container.component';
import { DialogFooterComponent } from './dialog-footer/dialog-footer.component';
import { DialogHeaderComponent } from './dialog-header/dialog-header.component';
import { DialogData, DialogInjector } from './dialog-injector';
import { DialogOpenerService } from './dialog-opener.service';
import { DialogRef } from './dialog-ref';
import { DialogToolbarComponent } from './dialog-toolbar/dialog-toolbar.component';
import { DialogComponentI } from './dialog.component';

export function overlayLevelFactory(level: number) {
  return Number.isInteger(level) ? level : 0;
}

@NgModule({
  imports: [
    RtUICommonModule,
    DialogCloseModule,
    DialogHeaderComponent,
    DialogContainerComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogToolbarComponent,
  ],
  providers: [
    {
      provide: 'overlayLevel',
      useFactory: overlayLevelFactory,
      deps: [[new Optional(), new SkipSelf(), new Inject('overlayLevel')]],
    },
  ],
  exports: [
    DialogContainerComponent,
    DialogCloseModule,
    DialogHeaderComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogToolbarComponent,
  ],
})
export class RtUIDialogModule {}

export {
  DialogOpenerService,
  DialogRole,
  DialogConfig,
  DialogConfigOptions,
  buildDialogConfig,
  DialogRef,
  DialogData,
  DialogInjector,
  DialogContainerAnimationState,
  DialogContainerComponent,
  DialogComponentI,
  DialogWidth,
};
